import { render, staticRenderFns } from "./queryCurrentUserPlcCompany.vue?vue&type=template&id=31653ce0&scoped=true"
import script from "./queryCurrentUserPlcCompany.vue?vue&type=script&lang=js"
export * from "./queryCurrentUserPlcCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31653ce0",
  null
  
)

export default component.exports